if (!customElements.get('cbd-language-selector')) {
  customElements.define('cbd-language-selector', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const disclosure = this.querySelector('details');
      const trigger = this.querySelector('summary');
      const links = [...this.querySelectorAll('.cbd-language-selector__link')];
      if (!disclosure || !trigger || !links.length) return;

      document.addEventListener('pointerdown', (event) => {
        if (disclosure.open && !this.contains(event.target)) disclosure.open = false;
      }, { signal });

      document.addEventListener('focusin', (event) => {
        if (disclosure.open && !this.contains(event.target)) disclosure.open = false;
      }, { signal });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && disclosure.open) {
          event.preventDefault();
          disclosure.open = false;
          trigger.focus();
          return;
        }

        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        const index = links.indexOf(document.activeElement);
        if (document.activeElement !== trigger && index < 0) return;
        event.preventDefault();
        disclosure.open = true;
        let next;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = links.length - 1;
        else if (index < 0) next = event.key === 'ArrowUp' ? links.length - 1 : 0;
        else next = (index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
        links[next].focus();
      }, { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
